import {fetchGet} from "../libs/reqCommon"
const state = {
    menulist:[],
    allMenuList:[],
    navHidden:false,
    menuLogo:{},//logo地址
    menuLogoOther:{}
}
const	getters = {
    menulist: state => {
        return state.menulist;
    },
    menuLogo:state=>{
        return state.menuLogo
    }
}
const	mutations = {
    setRouter:(state,payLoad) => {
        state.menulist = payLoad.menus
    },
    getAllMenulist:(state,payLoad)=>{
        state.allMenuList = payLoad
    },
    changeHidenMenu:(state,payLoad) => {
        if(payLoad) state.navHidden= payLoad
        else{
            state.navHidden = !state.navHidden
        }
    },
    getMenuLogo:(state,payLoad)=>{
        state.menuLogo = payLoad
    },
    getMenuLogoOther:(state,payLoad)=>{
        console.log(payLoad)
        state.menuLogoOther = payLoad
    },
}
const	actions = {
    // 获取所有的菜单列表
    reqAllMenulist({ commit ,dispatch },query){
        fetchGet("/hcm/menu/getList",query).then(data =>{
            if(data.status=='10000'){
                commit('getAllMenulist',data.data)
            }
        })
    },
    selecthcmloginlogo({commit,dispatch}){
        let domainname=window.location.href.slice(0,window.location.href.indexOf('.'))
        console.log(domainname)
        fetchGet("/hcm/login/selecthcmloginlogo",{domainname:'gree'}).then(data =>{
            if(data.status=='10000'){
                commit('getMenuLogo',data.data.data)
            }
        })
    },
    selecthcmlogo({commit}){
        fetchGet("/hcm/userout/selecthcmlogo").then(data =>{
            if(data.status=='10000'){
                let result={}
                if(!data.data){
                    result={
                        navigationlogo:null,
                        zoomlogo:null
                    }
                }else result=data.data
                commit('getMenuLogoOther',result)
            }
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
